export default theme => ({
  paperClass: {
    position: 'fixed !important',
    width: '100%',
    zIndex: 9999,
    top: 0,
    background: theme.neutral[400],
    height: ({ showBar }) => showBar ? 112 : 0,
    overflow: 'hidden',
    transition: 'all 0.15s ease-out',
    borderRadius: 0 + ' !important'
  },
  icons: {
    color: theme.secondary[0]
  },
  rateStarsClass: {
    marginLeft: 8 + 'px !important'
  },
  courseInfo: {
    display: 'flex',
    flexDirection: 'column'
  },
  actions: {
    width: '100%'
  },
  infos: {
    display: 'flex',
    alignItems: 'center'
  },
  row: {
    alignItems: 'center',
    height: '100%'
  },
  priceContainer: {
    display: 'flex',
    alignItems: 'baseline'
  }
})
